import axios from 'axios'

export const API = (currentUser: any) =>
  axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URI,
    headers: {
      Authorization: currentUser.tokens.idToken.toString(),
    },
  })
